export const events = ['start', 'frame', 'pause', 'resume', 'stop', 'rest'];